import { render, staticRenderFns } from "./VdoLiveSetList.vue?vue&type=template&id=17ca7706&scoped=true&"
import script from "./VdoLiveSetList.vue?vue&type=script&lang=js&"
export * from "./VdoLiveSetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ca7706",
  null
  
)

export default component.exports